import { useCallback, useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { StyledToken } from 'hubspot-prosemirror/prosemirror/views/PersonalizationTokenView';
import { buildDisplayText } from './PersonalizationTokenInlinePlugin';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PersonalizationTokenInlineFallback({
  token,
  isRequired,
  onInsert,
  onCancel
}) {
  const [fallbackValue, setFallbackValue] = useState('');
  const displayText = buildDisplayText(token);
  const isInsertDisabled = Boolean(isRequired) && !fallbackValue.trim();
  const handleInsert = useCallback(() => {
    if (isInsertDisabled) return;
    onInsert(fallbackValue.trim() || undefined);
  }, [fallbackValue, isInsertDisabled, onInsert]);
  const handleKeyDown = useCallback(e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleInsert();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
    }
  }, [handleInsert, onCancel]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    padding: "400",
    "data-test-id": "personalization-token-inline-fallback",
    onMouseDown: e => {
      if (e.target.tagName !== 'INPUT') {
        e.preventDefault();
      }
    },
    children: [/*#__PURE__*/_jsx(StyledToken, {
      style: {
        alignSelf: 'flex-start'
      },
      "data-test-id": "personalization-token-inline-fallback-chip",
      children: displayText
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.personalizationToken.inlineDropdown.fallbackLabel"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        autoFocus: true,
        value: fallbackValue,
        onChange: e => setFallbackValue(e.target.value),
        onKeyDown: handleKeyDown,
        placeholder: I18n.text(isRequired ? 'hubspot-prosemirror.personalizationToken.inlineDropdown.fallbackPlaceholderRequired' : 'hubspot-prosemirror.personalizationToken.inlineDropdown.fallbackPlaceholder'),
        "data-test-id": "personalization-token-inline-fallback-input"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "xs",
        onClick: handleInsert,
        disabled: isInsertDisabled || undefined,
        "data-test-id": "personalization-token-inline-fallback-insert",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.personalizationToken.popover.insertButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "xs",
        onClick: onCancel,
        "data-test-id": "personalization-token-inline-fallback-cancel",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.personalizationToken.inlineDropdown.cancelButton"
        })
      })]
    })]
  });
}
PersonalizationTokenInlineFallback.displayName = 'PersonalizationTokenInlineFallback';